import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { withErrorBoundary } from 'react-error-boundary';
import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import OrgFormControl from 'components/Dashboard/OrgFormControl';
import MgmtOverviewNav from 'components/Dashboard/MgmtOverviewNav';
import { ManagementDashboardTab } from 'components/Dashboard/types';

const ManagementOverview = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(ManagementDashboardTab.Summary);

  const showSubscriptionTypeFilter =
    activeTab === ManagementDashboardTab.Summary;

  return (
    <>
      <Helmet title={`${t('Management Overview')} - Red Hat Learning`} />
      <div>
        <OrgFormControl
          showSubscriptionTypeFilter={showSubscriptionTypeFilter}
          setActiveTab={setActiveTab}
        />
        <MgmtOverviewNav activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
    </>
  );
};

export default withErrorBoundary(
  ManagementOverview,
  GenericViewError,
  handleError,
);
